var exports = {
  "Ln": "x14bf3cd8--7f2cb1--input-container",
  "YQ": "x14bf3cd8--7f2cb1--suggest-popup",
  "s9": "x14bf3cd8--7f2cb1--input-container-not-desktop",
};

module.exports = exports;
